/**
 * Payer Connections — AC-7 action targets and labels.
 */

import type { FoldedPayer, RailView } from './types';

/** Stedi's enrollment list, also used when a legacy row has no enrollment ID. */
export const STEDI_ENROLLMENTS_URL = 'https://portal.stedi.com/app/healthcare/enrollments';

export const OPEN_IN_STEDI_LABEL = 'Open in Stedi';

/** Open the enrollment responsible for the displayed status and action. */
export function stediLinkTarget(payer: FoldedPayer): string {
  if (payer.portalUrl) return payer.portalUrl;
  const enrollmentId = actionRail(payer)?.enrollmentId;
  return enrollmentId
    ? `${STEDI_ENROLLMENTS_URL}/${encodeURIComponent(enrollmentId)}`
    : STEDI_ENROLLMENTS_URL;
}

const RAIL_TIEBREAK_ORDER = ['837P', '835'];

/**
 * The rail an action and its event describe: the one whose state drove the
 * payer's fold, tie-broken 837P before 835 — the same rail
 * `foldPayers` took "what's happening" from, so the row's text and the
 * event's `enrollment_status` can never disagree.
 */
export function actionRail(payer: FoldedPayer): RailView | undefined {
  if (payer.selectedRail) return payer.selectedRail;
  // Legacy/synthetic folded payers may not carry the selected enrollment.
  const rails = Object.values(payer.rails).filter((rail): rail is RailView => Boolean(rail));
  const matching = rails.filter(rail => rail.state === payer.state);
  const candidates = matching.length > 0 ? matching : rails;
  return candidates.slice().sort((a, b) => {
    const aIdx = RAIL_TIEBREAK_ORDER.indexOf(a.transactionType);
    const bIdx = RAIL_TIEBREAK_ORDER.indexOf(b.transactionType);
    return (
      (aIdx === -1 ? RAIL_TIEBREAK_ORDER.length : aIdx) -
      (bIdx === -1 ? RAIL_TIEBREAK_ORDER.length : bIdx)
    );
  })[0];
}
